const $ = window.jQuery;

export default class Validation {
    isEmail(email) {
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    checkInputValLength(val, element) {
        let result = {
            isValid: true,
            errorMessage: '',
        };
        if (!element.attr('required')) {
            return result;
        }
        if (val.length === 0) {
            result['errorMessage'] = element.attr('data-error-required') ? element.attr('data-error-required') : '';
            result['isValid'] = false;
        } else if (val.length < 2 && element.attr('minlength') !== '1') {
            result['errorMessage'] = element.attr('data-error-length-min') ? element.attr('data-error-length-min') : '';
            result['isValid'] = false;
        } else if (val.length > 50) {
            result['errorMessage'] = element.attr('data-error-length-max') ? element.attr('data-error-length-max') : '';
            result['isValid'] = false;
        }
        return result;
    }

    setFieldError(i, j, message) {
        i.parentNode.classList.add('was-validated');
        i.classList.add('error');
        let fieldError = j.parent().find('.form-field__error');
        if (fieldError.length) {
            j.parent().addClass('form-field--error');
            fieldError.text(message);
        } else {
            j.parent().find('.invalid-feedback').text(message).addClass('custom');
        }
    }

    clearFieldError(i, j) {
        let fieldError = j.parent().find('.form-field__error');
        if (fieldError.length) {
            j.parent().removeClass('form-field--error');
            fieldError.text('');
        } else {
            j.parent().find('.invalid-feedback.custom').removeClass('custom');
        }
        j.removeClass('error');
    }

    validateInput(i) {
        if (!i) {
            return;
        }
        const self = this;
        let j = $(i);
        let v = j.val();
        let isValid = true;
        let errorMessage = '';
        if (j.data('type') === 'number') {
            i.value = i.value.replace(/[^\d,]/g, '');
        }
        if (j.data('type') === 'letters') {
            i.value = i.value.replace(/([\\!\(\)|"_№`~;%:?,.//@#$^&*+\-{}\]\[])+/g, '');
        }
        if (i.checkValidity() === false) {
            i.parentNode.classList.add('was-validated');
        } else {
            self.clearFieldError(i, j);
        }
        switch (j.attr('type')) {
            case 'email':
                if (v.length === 0) {
                    isValid = false;
                    errorMessage = j.attr('data-error');
                } else if (self.isEmail(v) === false) {
                    isValid = false;
                    errorMessage = j.attr('data-error-valid');
                } else {
                    if (
                        ~window.location.pathname.indexOf('checkout') &&
                        !j.hasClass('login') &&
                        !j.hasClass('is-filled')
                    ) {
                        $.ajax('/wp/wp-admin/admin-ajax.php?action=amenities_signup_email_validation', {
                            method: 'POST',
                            data: {
                                email: v,
                                security: window.twf && window.twf.account_nonce,
                            },
                            success: function (response) {
                                if (typeof response == 'object') {
                                    self.setFieldError(i, j, response.error);
                                }
                            },
                        });
                    }
                }
                break;
            case 'tel':
                let phone = v.replace(/[^0-9]/g, '');
                if (v.length === 0) {
                    isValid = false;
                    errorMessage = j.attr('data-error');
                } else if (phone.length > 15 || phone.length < 8) {
                    isValid = false;
                    errorMessage = j.attr('data-error-lenght');
                }
                break;
            case 'password':
                if (v.length === 0) {
                    isValid = false;
                    errorMessage = j.attr('data-error');
                } else if (v.length < 8) {
                    isValid = false;
                    errorMessage = j.attr('data-error-lenght');
                }
                break;
            case 'text':
                let result = self.checkInputValLength(v, j);
                isValid = result['isValid'];
                errorMessage = result['errorMessage'];
                break;
            case 'date':
                let result2 = self.checkInputValLength(v, j);
                isValid = result2['isValid'];
                errorMessage = result2['errorMessage'];
                break;
        }
        switch (j.attr('id')) {
            case 'billing_company':
                let result = self.checkInputValLength(v, j);
                isValid = result['isValid'];
                errorMessage = result['errorMessage'];
                break;
            case 'atid_gender':
                let gender = $('#atid_gender');
                if (gender.val() != 1) {
                    if (gender.val() != 2) {
                        isValid = false;
                        errorMessage = gender.attr('data-error-required');
                    } else {
                        isValid = true;
                    }
                } else {
                    isValid = true;
                }

                break;
            case 'subscription_start_date':
                let date = new Date();
                let current_date =
                    date.getFullYear().toString() +
                    (date.getMonth() + 1).toString().replace(/(^.$)/, '0$1') +
                    date.getDate().toString().replace(/(^.$)/, '0$1');
                let new_date = window.document
                    .getElementById('subscription_start_date')
                    .value.replace(/(\d{2}).(\d{2}).(\d{4})/, '$3$2$1');

                if (new_date < current_date && new_date.length > 0) {
                    isValid = false;
                    errorMessage = $('#subscription_start_date').attr('data-error');
                } else {
                    isValid = true;
                }

                break;
            case 'atid_dob':
                let result2 = self.checkInputValLength(v, j);
                isValid = result2['isValid'];
                errorMessage = result2['errorMessage'];
                break;
        }
        switch (j.attr('name')) {
            case 'postcode':
                if (v.length === 0) {
                    isValid = false;
                    errorMessage = j.attr('data-error');
                } else if (v.length < 4) {
                    isValid = false;
                    errorMessage = j.attr('data-error-length');
                }
                break;
        }
        if (!isValid) {
            self.setFieldError(i, j, errorMessage);
        }
    }

    initFormsValidation() {
        const self = this;
        $('form.needs-validation').each(function () {
            let form = $(this);
            let btn = form.find('button[type="submit"]');
            if (!btn) {
                btn = form.find('input[type="submit"]');
            }
            if (!btn) {
                return;
            }
            form.find('input.form-control, input.form-field__control').each(function (key, input) {
                $(input).on('change', function () {
                    self.validateInput(input);
                });
                if ($(input).attr('type') == 'date') {
                    $(input)
                        .off('change')
                        .on('change', function () {
                            self.validateInput(input);
                        });
                }
            });
            btn.off('click').on('click', function (e) {
                e.preventDefault();
                form.find('input.form-control, input.form-field__control').each(function (key, input) {
                    self.validateInput(input);
                });
                form.find('select.form-control, select.form-field__control').each(function (key, select) {
                    self.validateInput(select);
                });
                if (form.find('input.error').length > 0 || form.find('select.error').length > 0) {
                    return false;
                } else {
                    form.submit();
                }
            });
        });
    }

    initLoginFormValidation() {
        const self = this;
        if ($('form#customer_login_form').length > 0) {
            let form = $('form#customer_login_form');
            let btn = form.find('button[type="submit"]');
            let inputs = form.find('input.form-control, input.form-field__control');
            inputs.each(function (key, input) {
                $(input).on('keyup', function () {
                    self.validateInput(input);
                });
            });
            btn.on('click', function (e) {
                e.preventDefault();
                inputs.each(function (key, input) {
                    self.validateInput(input);
                });
                if (form.find('input.error').length > 0) {
                    return false;
                }
                let u_field = form.find('#username');
                let p_field = form.find('#password');
                if (!u_field || !p_field) {
                    return false;
                }
                let user_val = u_field.val();
                let pass_val = p_field.val();
                jQuery.ajax('/wp/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        username: user_val,
                        password: pass_val,
                        action: 'amenities_checkout_login',
                    },
                    beforeSend: function () {
                        btn.attr('disabled', 'disabled');
                        btn.addClass('loading');
                    },
                    complete: function () {
                        btn.removeAttr('disabled');
                        btn.removeClass('loading');
                    },
                    success: function (response) {
                        if (response.status == 'failed') {
                            if (response.message.incorrect_password) {
                                p_field.parent().addClass('was-validated');
                                p_field.addClass('error');
                                p_field
                                    .parent()
                                    .find('.invalid-feedback')
                                    .text(p_field.data('error-invalid'))
                                    .addClass('custom');
                            } else {
                                u_field.parent().addClass('was-validated');
                                u_field.addClass('error');
                                u_field
                                    .parent()
                                    .find('.invalid-feedback')
                                    .text(u_field.data('error-unknown'))
                                    .addClass('custom');
                            }
                        } else {
                            form.submit();
                        }
                    },
                });
            });
        }
    }

    initValidation() {
        const self = this;
        self.initFormsValidation();
        self.initLoginFormValidation();
    }

    init() {
        this.initValidation();
    }
}
